import {
  FETCH_CMSPAGE_FULFILLED,
  FETCH_CMSPAGE_PENDING,
  FETCH_CMSPAGE_REJECTED,
} from "../actions/getCmsPage";

export default function (state: boolean = false, action: any) {
  switch (action.type) {
    case FETCH_CMSPAGE_PENDING:
      return true;
    case FETCH_CMSPAGE_FULFILLED:
    case FETCH_CMSPAGE_REJECTED:
      return false;
    default:
      return state;
  }
}
